"use client";

function isAllowedHostname(
  hostname: string,
  allowedDomains: string[],
): boolean {
  return allowedDomains.some(
    (domain) => hostname === domain || hostname.endsWith(`.${domain}`),
  );
}
import { StytchB2BProvider as ProviderActualB2B } from "@stytch/nextjs/b2b";
import { createStytchB2BUIClient } from "@stytch/nextjs/b2b/ui";
import type { StytchClientOptions } from "@stytch/vanilla-js";
import type { ReactNode } from "react";

const stytchOptions: StytchClientOptions = {
  cookieOptions:
    typeof window !== "undefined" &&
    isAllowedHostname(window.location.hostname, [
      "groq.com",
      "groqcloud.net",
    ]) &&
    process.env.NEXT_PUBLIC_COOKIE_DOMAIN
      ? {
          path: "/",
          availableToSubdomains: true,
          domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
        }
      : {
          path: "/",
          availableToSubdomains: false,
        },
  endpointOptions: {
    apiDomain: "api.stytchb2b.groq.com",
    testApiDomain: "api.stytchb2b.groqcloud.net",
    dfpCdnDomain: "api.stytchb2b.groq.com",
    dfppaDomain: "gste.groq.io",
  },
};

// // Initialize the regular Stytch client (keeping for potential backwards compatibility)
// const stytch = createStytchHeadlessClient(
//   process.env.NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN || "",
//   stytchOptions,
// );

// Initialize the B2B Stytch client with UI components
const stytchB2B = createStytchB2BUIClient(
  process.env.NEXT_PUBLIC_STYTCH_B2B_PUBLIC_TOKEN || "",
  stytchOptions,
);

const StytchProvider = ({ children }: { children: ReactNode }) => {
  // Provide both providers to ensure compatibility, with B2B as the primary
  return <ProviderActualB2B stytch={stytchB2B}>{children}</ProviderActualB2B>;
};

export default StytchProvider;
